<template>
  <div class="create px-6 py-4">
    <lCrumbs :breadcrumb="breadcrumbItems" />

    <div class="w-full lg:w-8/12 mx-auto mt-12">
      <div class="text-2xl text-black text-center mb-4">
        Edit your todo
      </div>
      <div class="mb-8">
        <linput
          v-model="form.todo_text"
          placeholder="Type text here"
          class="text-black text-lg rounded-md resize-none  focus:outline-none focus:shadow-md p-4 w-full h-full"
          rows="10"
          :errorMessage="errors.todo_text"
          :error="errors.todo_text"
        ></linput>
      </div>
      <div class="mr-4 text-lg text-black">Current Due Date: {{form.due_date}}</div>
      <div class="flex justify-between mx-16">

        <div class="flex items-center">
          <div class="mr-4 text-lg text-black">Set due date:</div>
          <datetime
            :week-start="7"
            style="width: 170px; height: 40px"
            class="text-black border rounded border-grey-900 flex pl-4"
            type="datetime"
            format="format"
            v-model="form.due_date"
          />
        </div>
        <div>
          <lms-button class="btn-color" textColor="#fff" @click="handleSubmit"
            >Submit</lms-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Datetime } from "vue-datetime";
//import { DateTime as DT } from "luxon";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      errors: [],
      form: {
        due_date: "",
        todo_text: "",
      },
      format: "yyyy-MM-dd HH:mm:ss",
      breadcrumbItems: [
        {
          disabled: true,
          to: "/learner/todo",
          text: "All Todo",
        },
        {
          disabled: true,
          to: "#",
          text: "Edit Todo",
        },
      ],
    };
  },
  components: {
    datetime: Datetime,
    LmsButton: () => import("@/components/general/button"),
    linput: () => import("@/components/general/input"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),

  },
  computed: {
    ...mapGetters(["getTodo"]),
  },
  async mounted() {
    await this.fetchTodo({
      id: this.$route.params.id,
    });
    this.form = this.getTodo;
  },
  methods: {
    ...mapActions(["updateTodo", "fetchTodo"]),
    async handleSubmit() {
      if (this.form.due_date == "" || this.form.todo_text == "") {
        this.$Bus.$emit("notify", {
          type: "error",
          message: "All fields are compulsotry",
        });
      }
      this.errors = [];

      // this.form.due_date = DT.fromISO(this.form.due_date).toFormat(
      //   "yyyy-MM-dd hh:mm:ss"
      // );

      let res = await this.updateTodo(this.form);
      if (res.status == 200 || res.status == 201) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Todo updated successfully",
        });
        this.$router.go(-1);
        this.form = {};
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
          this.$Bus.$emit("notify", {
            type: "error",
            message: "An error occured",
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-color {
  background-color: color(lms-tenant) !important;
}
.vdatetime {
  .vdatetime-input {
    height: 20px;
    border: 1px solid cyan !important;
  }
}
</style>
